import {useTranslation} from '@aboutyou/i18n';
import {COLORS, GenericIconName, Icon, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {CSSProperties} from 'react';

export const RedeemCoinsError: React.FC<{
  className?: string;
  style?: CSSProperties;
}> = ({className, style}) => {
  const {t} = useTranslation();

  return (
    <Container className={className} style={style}>
      <TitleWrapper>
        <Icon
          size="M"
          asset={GenericIconName.CrossFill}
          fill={COLORS.NotificationsRed100}
        />
        <Text size="px20" weight="w500">
          {t('Oops, an error occured!')}
        </Text>
      </TitleWrapper>
      <Text size="px12" weight="w400" color="Grey0" textAlignment="center">
        {t(
          'We are having trouble converting your Coins into a discount right now. Please try again later.',
        )}
      </Text>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
